/**
 * Opt-in debug logging. Enable with either:
 *   REACT_APP_DEBUG=true     (env / .env.development.local — restart npm start)
 *   window.__DEBUG__ = true  (browser console, immediate)
 */
export function isDebugEnabled() {
    if (process.env.REACT_APP_DEBUG === 'true') return true;
    return typeof window !== 'undefined' && window.__DEBUG__ === true;
}

export function debugLog(...args) {
    if (!isDebugEnabled()) return;
    // eslint-disable-next-line no-console
    console.log(...args);
}

export function debugWarn(...args) {
    if (!isDebugEnabled()) return;
    // eslint-disable-next-line no-console
    console.warn(...args);
}

/** Always on under `npm start`, compiled out of production builds. */
export function devLog(...args) {
    if (process.env.NODE_ENV !== 'development') return;
    // eslint-disable-next-line no-console
    console.log(...args);
}
